export default "__VITE_ASSET__CLWLA4xl__"